function isSvgAnimationSupported() {
  return document.implementation.hasFeature(
    "http://www.w3.org/TR/SVG11/feature#AnimationEventsAttribute",
    "1.0"
  );
}

export default isSvgAnimationSupported;
